import { put, takeLatest, call } from "redux-saga/effects";
import getShiftsDefinitions from "sc/backend/oncall/partners/regions/get-shifts-definitions";
import listEngineers from "sc/backend/oncall/partners/engineers/list";
import getRegion from "sc/backend/oncall/partners/regions/get-by-id";
import {
  SCHEDULE_PAGE_LOAD,
  shiftsDefinitionsLoaded,
} from "../../actions/shifts-definitions";
import { engineersLoaded } from "../../actions/engineers";
import { regionPageLoaded } from "../../actions/regions";
import { showErrorPage } from "../../../../../actions/ui/location";

const schedulePageLoadSaga = function*(action) {
  try {
    const regionResult = yield call(getRegion, action.payload.regionId);
    yield put(regionPageLoaded(regionResult));

    const engineersResult = yield call(listEngineers);
    yield put(engineersLoaded(engineersResult.engineers));

    const result = yield call(getShiftsDefinitions, action.payload.regionId);
    yield put(shiftsDefinitionsLoaded(result));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(SCHEDULE_PAGE_LOAD, schedulePageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/shifts-definitions/page-load.js